<script lang="ts">
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'
	import Button, { ButtonType } from './Button.svelte'
	import { iconSizeMap } from './Icon/Icon.svelte'

	type IconSize = keyof typeof iconSizeMap

	interface Props {
		iconColor?: string
		onClick: () => void
		iconSize?: IconSize
		pressedIconColor?: string
		animationDuration?: number
	}

	let {
		onClick,
		iconSize = 'md',
		animationDuration = 2000,
		iconColor = '#002C4D80',
		pressedIconColor = '#BED2BC'
	}: Props = $props()

	let iconName: IconName = $state('copy')
	let isPressed = $state(false)

	function handleCopy() {
		if (isPressed) return
		isPressed = true
		iconName = 'checkmark'
		onClick()
		setTimeout(() => {
			iconName = 'copy'
			isPressed = false
		}, animationDuration)
	}

	const iconColorStyle = $derived(`color: ${iconName === 'copy' ? iconColor : pressedIconColor};`)
</script>

<Button
	buttonText=""
	buttonType={ButtonType.TERTIARY_INVERSE}
	rounded
	extraProps={iconColorStyle}
	iconProps={{ name: iconName, size: iconSize }}
	onclick={handleCopy}
/>
